export default "__VITE_ASSET__DQfYuiS2__"